import React, { useState, useEffect, Fragment } from 'react';

import clsx from 'clsx';
import { Form } from 'react-final-form';
import {
  required,
  // number,
  useDataProvider,
  useNotify,
  useRefresh,
  cacheDataProviderProxy,
} from 'react-admin';
import {
  DialogActions,
  DialogContent,
  DialogContentText,
} from '@material-ui/core';
import {
  ReferenceInput,
  FormTextField,
  handleNumbers,
  getDateInputValue,
} from '.';
import { useStyles } from '../modal.styles';
import { SaveButton } from '../../../../design';
export const GlobalRevCodesForm = ({
  record = {},
  isEdit,
  payerId,
  handleClose,
}) => {
  const classes = useStyles();
  const refresh = useRefresh();
  const dataProvider = cacheDataProviderProxy(useDataProvider());
  const notify = useNotify();
  const [formData, setFormData] = useState({});
  useEffect(() => {
    if (isEdit && record) {
      const { rev_codes: _rev_codes, ...rest } = record;
      const rev_codes =
        _rev_codes && Array.isArray(_rev_codes) ? _rev_codes.join(',') : '';
      setFormData(f => ({
        ...f,
        ...rest,
        rev_codes,
      }));
    }
  }, [isEdit, record]);

  const onSubmit = value => {
    if (isEdit) {
      return dataProvider
        .update('global-rev-codes', {
          id: record.id,
          data: {
            ...value,
          },
          previousData: { ...record },
        })
        .then(({ data }) => {
          notify('form.updated');
          handleClose();
          refresh();
        })
        .catch(error =>
          notify(
            typeof error === 'string'
              ? error
              : error.message || 'ra.notification.http_error',
            'warning',
          ),
        );
    } else {
      return dataProvider
        .create('global-rev-codes', { data: { payer_id: payerId, ...value } })
        .then(({ data }) => {
          notify('form.created');
          handleClose();
          refresh();
        })
        .catch(error =>
          notify(
            typeof error === 'string'
              ? error
              : error.message || 'ra.notification.http_error',
            'warning',
          ),
        );
    }
  };
  const customOnChange = async (eventOrValue, _name, type) => {
    // when using a react-admin input, onChange returns
    // the value instead of the target.
    let value = eventOrValue;
    let name = _name;
    if (typeof eventOrValue === 'object') {
      const target = eventOrValue.target;
      value = target.type === 'checkbox' ? target.checked : target.value;
      name = target.name;
    }
    if (type === 'number') {
      value = handleNumbers(value);
    }
    if (type === 'date') {
      value = getDateInputValue(value);
    }
    setFormData({ ...formData, [name]: value });
  };
  return (
    <Fragment>
      <Form
        onSubmit={onSubmit}
        initialValues={{
          // ...caseFields,
          ...formData,
        }}
        render={({
          submitError,
          handleSubmit,
          form,
          submitting,
          pristine,
          values,
        }) => {
          return (
            <form onSubmit={handleSubmit}>
              <DialogContent>
                {isEdit && (
                  <DialogContentText color={'error'} variant='subtitle2'>
                    Note: Changing this rev code will update all contracts that
                    did not put a different rev code for this level.
                  </DialogContentText>
                )}
                <div className={clsx(classes.inputContainerWrap)}>
                  <ReferenceInput
                    key={1}
                    reference='auth-types/list'
                    customOnChange={customOnChange}
                    name='level'
                    label='Level'
                    validate={required()}
                    required
                    options={{
                      filter: {
                        rate: 1,
                        part_b_excluded: !!formData.part_b_excluded,
                      },
                    }}
                    style={{ marginRight: 0 }}
                  />
                  <FormTextField
                    name='rev_codes'
                    label='Rev codes'
                    customOnChange={customOnChange}
                    fullWidth
                    style={{ marginRight: 0 }}
                    required
                    validate={required()}
                  />
                </div>
              </DialogContent>
              <DialogActions
                className={classes.padding16}
                style={{ paddingBottom: 16 }}
              >
                <SaveButton
                  // onClick={handleClose}
                  className={classes.saveButton}
                  disabled={submitting}
                  type='submit'
                />
              </DialogActions>
            </form>
          );
        }}
      />
    </Fragment>
  );
};
